"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayMove = void 0;
function arrayMoveMutate(array, from, to) {
    const startIndex = to < 0 ? array.length + to : to;
    const item = array.splice(from, 1)[0];
    array.splice(startIndex, 0, item);
}
/**
 * Swaps elements in array and create new copy.
 *
 */
function arrayMove(array, from, to) {
    array = array.slice();
    arrayMoveMutate(array, from, to);
    return array;
}
exports.arrayMove = arrayMove;
//# sourceMappingURL=array-move.js.map